<template>
  <DModal :show-close="false" :isBgOverlay="true" @close="$emit('close')" :appendToBody="true"
          style="z-index: 12312312312312">
    <div class="d-modal" id="d-create-task-for-user" slot="insertComponent">
      <div class="d-modal__header">
        <h2>
          {{ theEditSupplementType ? theEditSupplementType.title : 'Tilføj ny tillægsstype' }}
        </h2>
        <div class="font-large icon__bg-circle d-modal__header__close" @click="$emit('close')"><span
          class="icon-cross2"></span>
        </div>
      </div>
      <div class="d-modal__content">
        <template v-if="!theEditSupplementType">
          <div class="d-input-group">
            <label class="d-label">Titel</label>
            <input type="text" class="d-input" v-model="title" ref="title_input">
          </div>
          <div class="d-input-group">
            <label class="d-label">Tillægskode</label>
            <input type="text" class="d-input" v-model="code">
          </div>
          <div class="d-input-group">
            <label class="d-label">Konto</label>
            <input type="text" class="d-input" v-model="account">
          </div>
        </template>
        <template v-else>
          <div class="d-input-group">
            <label class="d-label">
              Vælg udløbsdato
            </label>
            <DateSelector :date="endDate" :width100="true"></DateSelector>
          </div>
        </template>
      </div>
      <div class="d-modal__buttons">
        <div>
          <button class="do-bttn" @click="$emit('close')">{{ $t('vue2.common.cancel') }}</button>
          <button class="do-bttn do-bttn--submit do-bttn--submit--disabled" v-if="!theEditSupplementType && !isValid">
            Opret
          </button>
          <button class="do-bttn do-bttn--submit" :class="{'do-bttn--submit--loading': isSubmitting}"
                  @click="onSubmit"
                  v-if="!theEditSupplementType && isValid">
            Opret
          </button>
          <button class="do-bttn do-bttn--submit" v-if="theEditSupplementType" @click="update">Gem</button>
        </div>
      </div>
    </div>
  </DModal>
</template>

<script>
import DModal from '../common/DModal.vue'
import DateSelector from '../datepicker/DateSelector.vue'
import moment from 'moment'

export default {
  components: {DateSelector, DModal},
  props: {
    isSubmitting: {
      type: Boolean,
      default: false
    },
    theEditSupplementType: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      title: '',
      code: '',
      account: '',
      endDate: moment()
    }
  },
  computed: {
    isValid () {
      return this.title.length > 0
    }
  },
  methods: {
    onSubmit () {
      const obj = {
        title: this.title,
        code: this.code,
        account: this.account
      }
      this.$emit('save', obj)
    },
    update () {
      this.$emit('update', this.endDate)
    }
  },
  mounted () {
    const el = this.$refs.title_input
    if (el) {
      el.focus()
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.d-modal {
  width: 500px;
  border-radius: 16px;
  position: relative;
}

.d-modal__header {
  margin-bottom: 0;
  text-align: left;
}

.d-modal__buttons {
  display: flex;
  justify-content: flex-end;
  padding: 1rem 2rem;
}

.d-modal__buttons > div {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.d-modal__content {
  padding: 1rem;
}

.d-input-group--toggler {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 1rem;
  border-radius: 4px;
  cursor: pointer;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px -1px rgba(0, 0, 0, .1);
}

.d-input-group--toggler.d-input-group--toggler--active > .d-label {
  color: var(--dark-blue);
}

.d-input-group--toggler > .d-label {
  margin-bottom: 0;
  cursor: pointer;
}

.d-input-group--toggler:hover {
  background: #f0f8ff;
}

.d-input-group .d-input {
  height: 34px;
}

.d-input-group {
  margin-bottom: 2rem;
}

</style>



// WEBPACK FOOTER //
// CreateSupplementstype.vue?d8d45cb8